<template>
	<div style="height: 84vh;">
		<div class="tenant_search">
			<div class="tenant_search_1">
				<i class="ione"></i>
				<el-input placeholder="请输入锁名称" prefix-icon="el-icon-search" v-model="data.alias" @keyup.enter.native="search()"
					@change="handleStatusChange"></el-input>

			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-select v-model="data.status" placeholder="房间状态" @change="handleStatusChange">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>


			<div style="display: flex;justify-content: space-between;width: 100%;align-items: center;"
				:style="{ marginLeft: minw ? '1rem' : '0' ,marginRight: minw ? '1rem' : '0'}">
				<div>
					<button class="search_button" @click="search()">搜索</button>
					<button class="search_button" @click="search('重置')">重置</button>
				</div>
				<div v-show="minw" style="display: flex;align-items: center;">
					<p style="color: #909399;">{{launched?'收起':'展开'}}</p>
					<i size="mini" :class="launched?'el-icon-arrow-up':'el-icon-arrow-down'" @click="launched=!launched"></i>
				</div>

			</div>
		</div>
		<ListingButton :lists="lists" @add='add'></ListingButton>
		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			@lockinit="lockinit" @roominit="roominit" style="margin: 1rem;"></MyTable>
		<MyDialog :item="EditValue" :DialogTitle="DialogTitle" @changedia="changedia"
			:centerDialogVisible="centerDialogVisible"></MyDialog>
		<Mycell :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			@lockinit="lockinit" @roominit="roominit" style="padding-bottom: 4rem;"></Mycell>
	</div>
</template>

<script>
	import ListingButton from "@/components/Listing_Button/index.vue"
	import MyTable from "@/components/MyTable/index.vue"
	import MyDialog from "@/components/My_dialog/index.vue"
	import Mycell from "@/components/My_cell/index.vue"
	import {
		lock_list,
		lock_init
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: 'Lock',
				lists: [{
					name: '添加',
					type: 'primary',
					icon: 'el-icon-plus',
					funt: 'add'
				}],
				tableData: [],
				table_label: [{
					label: '识别码',
					value: 'lockId'
				}, {
					label: '蓝牙名称',
					value: 'lockName'
				}, {
					label: '锁别名',
					value: 'lockAlias'
				}, {
					label: '剩余电量',
					value: 'electricQuantity'
				}, {
					label: '连接网关',
					value: 'hasGateway'
				}, {
					label: '初始化时间',
					value: 'date'
				}, {
					label: '绑定房间号',
					value: 'room_num'
				}, {
					label: '门锁密码',
					value: 'keyboardPwd'
				}, {
					label: '密码类型',
					value: 'pwdType'
				}, {
					label: '房间状态',
					value: 'status'
				}],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					limit: 15,
					alias: '',
					status: ''
				},
				options: [{
					value: 0,
					label: '未出租'
				}, {
					value: 1,
					label: '出租中'
				}, ],
				minw: JSON.parse(sessionStorage.getItem('minw')),
				launched: !JSON.parse(sessionStorage.getItem('minw')),
				search_status: false
			}
		},
		methods: {
			search(resetting) {

				if (resetting != undefined) {
					this.data.status = ''
					this.data.alias = ''
					this.contractlistcontractlist(1)
				} else {
					sessionStorage.setItem(this.$router.currentRoute.path + 'search_status', 1);
					this.contractlistcontractlist('搜索')
				}
			},
			handleStatusChange() {
				sessionStorage.setItem(this.$router.currentRoute.path + 'search_status', 0);
			},
			async contractlistcontractlist(value) {
				if (value == '搜索') {
					this.data.page = 1
				} else if (sessionStorage.getItem(this.$router.currentRoute.path + 'search_status') == 1) {
					this.data.page = value ? value : this.data.page
				} else {
					this.data = {
						page: value ? value : this.data.page,
						limit: 15
					}
				}
				let res = await lock_list(this.data);

				if (res.status == 200) {
					res.data.list.forEach(item => {
						item.hasGateway = (!item.hasGateway || item.hasGateway == 0) ? '否' : '是';
					});
					const list = res.data.list.map(item => {
						const {
							keyboardPwd = '--',
								keyboardPwdName = '--'
						} = item.pwds || {};
						const pwdType = keyboardPwdName === '系统专用' ? '长期' : '临时';
						return {
							...item,
							keyboardPwd,
							pwdType
						};
					});

					console.log();
					this.tableData = list;
					this.total = res.data.count;
					if (res.__requestPayload) {
						this.data = res.__requestPayload
					}
				}
			},
			add() {
				this.centerDialogVisible = true
				this.DialogTitle = '添加门锁设备'
			},
			//点击编辑
			Edit(value) {
				console.log('Edit', value);
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '编辑门锁'
			},
			// 批量删除的数组
			DeleteValue(value) {
				this.multipleSelection = value
			},
			// 批量删除的方法
			BatchDelete() {
				contract_delete({
					id: this.multipleSelection
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
				console.log(111);
			},
			// 点击删除
			Delete(value) {
				console.log("Delete", value.id);
				contract_delete({
					id: value.id
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			async lockinit(value) {
				console.log(value);
				this.$confirm(`是否修改门锁别名：${value.lockAlias}的密码？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true,
					customClass: 'my-confirm-dialog'
				}).then(() => {
					lock_init(value.lockId).then(res => {
						this.Messages(res)
						this.contractlistcontractlist()
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
				// let res = await lock_init(value.lockId)
				// this.Messages(res)
				// this.contractlistcontractlist()
			},
			// 绑定房间
			roominit(value) {
				console.log('Edit', value);
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '绑定房间'
			},
			changedia(value) {
				this.centerDialogVisible = value
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		components: {
			MyTable,
			ListingButton,
			MyDialog,
			Mycell
		},
		created() {
			this.contractlistcontractlist()
		}
	}
</script>

<style scoped>
	.tenant_search {
		display: flex;
		align-items: center;
		background-color: var(--cont_backgound);
		margin: 1.25rem;
		padding: 10px;
		border-radius: 8px;
	}

	::v-deep .el-input__inner:focus {
		border: 1px solid #3C46FF;
	}

	.tenant_search_1 {
		display: flex;
		align-items: center;

	}

	.tenant_search_1 span {
		width: 2.6rem;

	}

	.tenant_search .tenant_search_1:first-child i {
		margin-left: 0rem;
	}

	.tenant_search_1 i {
		height: 1.25rem;
		width: 0.375rem;
		background-color: #3C46FF;
		border-radius: 0.625rem;
		margin: 0 0.625rem;
		margin-left: 1rem;
	}

	.tenant_search :nth-child(2) span {
		width: 4.8rem;
	}


	.tenant_search_1 .el-input {
		width: 10rem;
	}

	.search_button {
		font-size: 0.85rem;
		height: 2rem;
		width: 5rem;
		margin: 0 0.625rem;
		background-color: #409eff;
		border: #409eff;
		color: #fff;
		border-radius: 6px;
	}

	.search_button:hover {
		opacity: 0.8;
	}
</style>